import React, { useState, useEffect } from "react";
////////////////////////////////////////
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import DirectionSnackbar from "../Alert/Alert";
import bcrypt from "bcryptjs";
import { useNavigate } from "react-router-dom";
import SignInCard from "./SigninSite";
import Stack from "@mui/material/Stack";


//////////////////////////////////////////////////////////////////
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Content from "../Content/ContentIn";
import CopyrightFooter from "../Footer/Copyright";
import { useAuth } from "../Auth/AuthProtecter";

const defaultTheme = createTheme();

export default function Sign({ name, ...pros }) {
  //
  const auth = useAuth();
  //
  const url = process.env.REACT_APP_API_SINGIN_ADMIN; // Email valid
  const urlpass = process.env.REACT_APP_API_SINGIN_ADMIN_PASS; // Pass Valid

  const [checkedUser, setCheckedUser] = React.useState(false);

  const [iduser, setId] = useState(pros.id);
  const [status, setStatus] = useState(false);
  const [messenger, setMessenger] = useState("");
  const [error, setError] = useState(false);
  const [errorpss, setErrorpss] = useState(false);
  const [severity, setSeverity] = useState("");
  const [Statusl, setStatusl] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    //
    if (auth.isAuthenticated) {
      navigate("/application", { replace: true });
    }
    //
  });

  const salt = bcrypt.genSaltSync(10);

  const RegisterSchema = Yup.object().shape({
    email: Yup.string()
      .email("Ingrese un Email valido ejemplo: proyect_bussines@correo.com")
      .required("Ingresa tu Email de administrador."),
    pass: Yup.string()
      .required("No se proporcionó contraseña.")
      .min(
        8,
        "La contraseña es demasiado corta; debe tener un mínimo de 8 caracteres."
      )
      .matches(/[a-zA-Z]/, "La contraseña debe contener letras."),
  });

  const defaultValues = {
    username: "",
    code: "",
    email: "",
    pass: "",
    pass2: "",
  };

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (e) => {
    const values = {
      email: e.email,
    };
    //// EMAIL
    try {
      const CONFIG_JSON = {
        method: "POST",
        headers: {
          referrerPolicy: "unsafe_url",
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          mode: "same-origin",
        },
        body: JSON.stringify(values),
      };

      const res = await fetch(`${url}`, CONFIG_JSON);
      const res_api = await res.json();
      //
      /////////// PASSWORD /////////////////////////
      if (res.status === 200) {
        ///// PASSSS
        if (res_api[0]) {
          const passbcry = bcrypt.hashSync(e.pass, res_api[0].pass2);
          const valuespss = {
            email: e.email,
            pass: passbcry,
          };

          try {
            const jsonpass = {
              method: "POST",
              headers: {
                referrerPolicy: "unsafe_url",
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                mode: "same-origin",
              },
              body: JSON.stringify(valuespss),
            };

            const respass = await fetch(`${urlpass}`, jsonpass);
            const res_pass = await respass.json();
            console.log(res_pass[0]);

            // 192.168.200.197//appointmentAPI/public/mngmapmtcustomer.php
            if (res_pass[0]) {
              setStatusl(200);
              //pros.history.push("/dashboard");
            }
            /////// Cuando la clave es invalida
            if (res_pass === 404) {
              setErrorpss(true);
            }
          } catch (error) {
            if (error) {
              setStatus(true);
              setMessenger("Ups, error de conexión");
              setSeverity("error");
            }

            window.setTimeout(() => {
              setStatus(false);
            }, 4000);
          }
        }
      }

      /////// Cuando no exite el usuario.
      if (res_api === 404) {
        setError(true);
      }

      /////// ERROR CONSULTA
      if (res.status !== 200) {
        setStatus(true);
        setMessenger("Servidor no responde");
        setSeverity("error");
      }

      window.setTimeout(() => {
        setStatus(false);
        setError(false);
        setErrorpss(false);
      }, 4000);
    } catch (error) {
      if (error) {
        setStatus(true);
        setMessenger("Ups, error de conexión");
        setSeverity("error");
      }

      window.setTimeout(() => {
        setStatus(false);
      }, 4000);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <DirectionSnackbar
        open={status}
        severity={severity}
        messenger={messenger}
      />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: "center",
            height: "calc((1 - var(--template-frame-height, 0)) * 100%)",
            marginTop: "max(40px - var(--template-frame-height, 0px), 0px)",
            minHeight: "100%",
          },
          (theme) => ({
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              zIndex: -1,
              inset: 0,
              backgroundImage:
                "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
              backgroundRepeat: "no-repeat",
              ...theme.applyStyles("dark", {
                backgroundImage:
                  "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
              }),
            },
          }),
        ]}
      >
        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          sx={{
            justifyContent: "center",
            gap: { xs: 6, sm: 12 },
            p: 2,
            mx: "auto",
          }}
        >
          <Stack
            direction={{ xs: "column-reverse", md: "row" }}
            sx={{
              justifyContent: "center",
              gap: { xs: 6, sm: 12 },
              p: { xs: 2, sm: 4 },
              m: "auto",
            }}
          >
            <Content />

            <Container component="main" maxWidth="xs">
              <CssBaseline />
 

              <SignInCard setCheckedUser={setCheckedUser} />

            </Container>
          </Stack>
        </Stack>
      </Stack>
      <CopyrightFooter sx={{ mt: 5 }} />
      {/* <CopyrightFooter sx={{ mt: 5 }} /> */}
    </ThemeProvider>
  );
}
